import { createRoot } from 'react-dom/client';

import AllProvider from './AllProvider';
import App from './App';

const img = new Image();
img.src = `${process.env.PUBLIC_URL}/assets/svg/gdflix_logo.svg`;


const el = document.getElementById('root');

if (el) {
  const root = createRoot(el);
  root.render(
    <AllProvider>
      <App />
    </AllProvider>
  )
}

console.log('Website by %c https://gdi.re.kr ', `
  font-size: 14px; 
  line-height: 44px;
  color: #001489;
  background-color:rgb(255, 255, 255)`
);